module.exports = __webpack_public_path__ + "img/green_065.ae929677.png";